import { API, APICall } from '../Api'

export default {
  name: 'Cars',

  methods: {
    async get (id) {
      const Request = {
        Type    : APICall.Car.Get.Type,
        Endpoint: APICall.Car.Get.Endpoint.replace('{id}', id),
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async save (data) {
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      const Request = {
        Type    : APICall.Car.Save.Type,
        Endpoint: APICall.Car.Save.Endpoint,
        Data    : data
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async all (data) {
      const Request = {
        Type    : APICall.Car.List.Type,
        Endpoint: APICall.Car.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async getBrand (id) {
      const Request = {
        Type    : APICall.Car.Brand.Get.Type,
        Endpoint: APICall.Car.Brand.Get.Endpoint.replace('{id}', id),
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async saveBrand (data) {
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      const Request = {
        Type    : APICall.Car.Brand.Save.Type,
        Endpoint: APICall.Car.Brand.Save.Endpoint,
        Data    : data
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async allBrands (data) {
      const Request = {
        Type    : APICall.Car.Brand.List.Type,
        Endpoint: APICall.Car.Brand.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async getType (id) {
      const Request = {
        Type    : APICall.Car.Type.Get.Type,
        Endpoint: APICall.Car.Type.Get.Endpoint.replace('{id}', id),
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async saveType (data) {
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      const Request = {
        Type    : APICall.Car.Type.Save.Type,
        Endpoint: APICall.Car.Type.Save.Endpoint,
        Data    : data
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async allTypes (data) {
      const Request = {
        Type    : APICall.Car.Type.List.Type,
        Endpoint: APICall.Car.Type.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    }

  }

}
